import { extendObservable, makeAutoObservable, isObservable, toJS } from "mobx";

import { FilePondInitialFile } from "filepond";
import TbComFileMapngDetail from "./mapng/TbComFileMapngDetail";

/**
 * 공통 - 파일
 */
export default class TbComFile {
  public fileId!: string;
  public relateId!: string;
  public tbComFileMapngDetailList!: Array<TbComFileMapngDetail>;
  public files: Array<FilePondInitialFile | File> = [];

  public constructor(data?: any) {
    if(data) {
      extendObservable(this, data);
      // set(this, data);

      if (data.tbComFileMapngDetailList) {
        this.tbComFileMapngDetailList = data.tbComFileMapngDetailList.map(detail => {
          let planJs = detail;
          if(isObservable(detail)) {
            planJs = toJS(detail);
          }
          const dt = extendObservable(new TbComFileMapngDetail(), planJs)

          return dt;
        });
      }
      else {
        this.tbComFileMapngDetailList = [];
      }
    }
    else {
      makeAutoObservable(this);
      this.tbComFileMapngDetailList = [];
    }
  }

  public setTbComFileMapngDetailList(tbComFileMapngDetailList: TbComFileMapngDetail[]) {
    this.tbComFileMapngDetailList = tbComFileMapngDetailList;
  }

  public putTbComFileMapngDetailList(tbComFileMapngDetailList: TbComFileMapngDetail) {
    this.tbComFileMapngDetailList.push(tbComFileMapngDetailList);
  }

  public setFiles(files: Array<FilePondInitialFile | File>) {
    this.files = files;
  }

  public setRelateId(value: string) {
    this.relateId = value;
  }
  public setFileId(value: string) {
    this.fileId = value;
  }
}
